'use strict';

(function() {
    const cookieName = 'af-maps-consent';

    $(document).on('click',
        '#consent-maps-yes',
        function() {
            af.setCookie(cookieName, 'y', 7, true);
            let main = document.querySelector('main');
            sessionStorage.setItem('scrollpos', main.scrollTop);

            if (this.getAttribute('data-open-target-after-reload') !== '') {
                sessionStorage.setItem('opentargetafterreload', this.getAttribute('data-open-target-after-reload'));
            }

            location.reload();
        });
})();